'use strict';

var _ = require('lodash');
var StrategiesStateService = function StrategiesStateService(configurationService) {
  var deleteButtonVisible = false;
  var duplicateButtonVisible = false;
  var selectedRows = null;
  var selectedRow = null;
  function allowedToDelete() {
    return _.every(selectedRows, function (element) {
      var userDisplayName = configurationService.getUserDisplayName();
      var userId = configurationService.getUserId();
      var isOwner = userDisplayName === element.createdBy || userId === element.createdBy;
      var isRestricted = element.isRestricted;
      if (typeof isRestricted === 'string') {
        isRestricted = isRestricted.toLowerCase() === 'yes';
      }
      return !element.isQuickRule && (isOwner || !isRestricted);
    });
  }
  function setSelectedRows(rows) {
    var singleRowSelected = rows.length === 1;
    var someRowsSelected = rows.length > 0;
    selectedRows = rows;
    deleteButtonVisible = someRowsSelected;
    duplicateButtonVisible = singleRowSelected;
    selectedRow = singleRowSelected ? selectedRows[0] : null;
    return selectedRow;
  }
  function getSelectedRows() {
    return selectedRows;
  }
  function getSelectedRow() {
    return selectedRow;
  }
  function isDeleteButtonVisible() {
    return selectedRows.length > 0 && allowedToDelete();
  }
  function isDuplicateButtonVisible() {
    return selectedRows.length === 1 && !selectedRows[0].isQuickRule;
  }
  return {
    isDeleteButtonVisible: isDeleteButtonVisible,
    isDuplicateButtonVisible: isDuplicateButtonVisible,
    setSelectedRows: setSelectedRows,
    getSelectedRows: getSelectedRows,
    getSelectedRow: getSelectedRow
  };
};
StrategiesStateService.$inject = ['ConfigurationService'];
module.exports = StrategiesStateService;